import * as React from 'react';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {Button, Table} from 'react-bootstrap';
import Alert from 'react-bootstrap/Alert';
import {faTimes} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Action, Trash} from '../../../system/buttons';
import {FileUploader} from '../../../system/file';

export default class PictureBpmEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props.configuration,
      visibilityDraft: true,
      pictureUrlDraft: undefined,
      showRangePicker: false,
    };
  }

  handleRemove = (index) => () => {
    const ranges = [...this.state.ranges];
    ranges.splice(index, 1);
    this.setState({ranges});
  };

  handleRangeColorDraftComplete = (url) => {
    this.setState({pictureUrlDraft: url});
  };

  handleVisibility = (event) => {
    this.setState({visibilityDraft: event.target.checked});
  };

  between(a, from, to) {
    return a >= from && a <= to;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState !== this.state) {
      this.props.onUpdate({
        ranges: this.state.ranges,
        gallery: this.state.gallery,
      });
    }
  }

  handleNew = () => {
    const ranges = [...this.state.ranges];
    const concerns = [];
    const from = parseInt(this.state.fromDraft);
    if (isNaN(from)) {
      concerns.push('from is not a number');
    }

    const to = parseInt(this.state.toDraft);
    if (isNaN(to)) {
      concerns.push('to is not a number');
    }
    if (to < from) {
      concerns.push('from is grater than to');
    }

    let index;

    for (index in ranges) {
      const current = ranges[index];
      if (this.between(from, current.from, current.to)) {
        concerns.push(
          from +
            ' (from) intersects with [' +
            current.from +
            ',' +
            current.to +
            ']'
        );
      }
      if (this.between(to, current.from, current.to)) {
        concerns.push(
          to + ' (to) intersect [' + current.from + ',' + current.to + ']'
        );
      }
    }

    if (concerns.length === 0) {
      ranges.push({
        from: from,
        to: to,
        pictureUrl: this.state.visibilityDraft
          ? this.state.pictureUrlDraft
          : undefined,
      });

      ranges.sort(function (a, b) {
        return a.from - b.from;
      });

      this.setState({ranges, concerns: undefined});
    } else {
      this.setState({concerns});
    }
  };

  handleFromChange = (event) => {
    this.setState({fromDraft: event.target.value});
  };

  handleToChange = (event) => {
    this.setState({toDraft: event.target.value});
  };

  handleFileUploaded = (fileUrl) => {
    let gallery = this.state.gallery;
    gallery.push(fileUrl);
    this.setState({gallery}, () => this.saveConfiguration());
  };

  handlePictureDelete = (url) => () => {
    this.setState(
      {gallery: this.state.gallery.filter((urll) => urll !== url)},
      () => this.saveConfiguration()
    );
  };

  saveConfiguration = () => {
    this.props.onSave({
      ranges: this.state.ranges,
      gallery: this.state.gallery,
    });
  };

  render() {
    return (
      <>
        <div>
          <h4>Add new range</h4>

          <FileUploader onFileUploaded={this.handleFileUploaded} />

          <Form.Group as={Row}>
            <Form.Label column sm="2">
              From
            </Form.Label>
            <Col sm="3">
              <Form.Control type="number" onChange={this.handleFromChange} />
            </Col>
          </Form.Group>

          <Form.Group as={Row}>
            <Form.Label column sm="2">
              To
            </Form.Label>
            <Col sm="3">
              <Form.Control type="number" onChange={this.handleToChange} />
            </Col>
          </Form.Group>

          <Form.Group as={Row}>
            <Form.Label column sm="2">
              Is visible
            </Form.Label>
            <Col sm="3">
              <Form.Check
                checked={this.state.visibilityDraft}
                onChange={this.handleVisibility}
              />
            </Col>
          </Form.Group>
        </div>

        <div>
          {this.state.visibilityDraft && (
            <Form.Group as={Row}>
              <Form.Label column sm="2">
                Picture
              </Form.Label>

              <Col sm="9">
                {this.state.gallery &&
                  this.state.gallery.map((url) => {
                    let style = {height: '100px'};
                    if (url === this.state.pictureUrlDraft) {
                      style.border = '5px solid black';
                    }
                    return (
                      <Row>
                        <img
                          alt={'img here'}
                          onClick={() => this.setState({pictureUrlDraft: url})}
                          style={style}
                          src={url}
                        />

                        <FontAwesomeIcon
                          icon={faTimes}
                          onClick={this.handlePictureDelete(url)}
                        />
                      </Row>
                    );
                  })}
              </Col>
            </Form.Group>
          )}

          <Form.Group>
            <Button onClick={this.handleNew} variant={'success'}>
              Add
            </Button>
          </Form.Group>
        </div>

        {this.state.concerns && (
          <Alert variant="warning">
            <h5>Can't add new range</h5>
            <ul>
              {this.state.concerns.map((concern) => (
                <li>{concern}</li>
              ))}
            </ul>
          </Alert>
        )}

        <hr />

        <h4>Configured ranges</h4>
        <Table striped bordered size="sm">
          <thead>
            <tr>
              <th
                style={{
                  textAlign: 'center',
                }}
              >
                Range
              </th>
              <th style={{textAlign: 'center'}}>Picture</th>
              <th
                style={{
                  textAlign: 'center',
                }}
              >
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {this.state.ranges.map((range, index) => {
              return (
                <tr>
                  <td style={{textAlign: 'center'}}>
                    {range.from} - {range.to}
                  </td>
                  <td style={{textAlign: 'center'}}>
                    {range.pictureUrl ? (
                      <img
                        style={{height: '100px'}}
                        src={range.pictureUrl}
                        alt={'img here'}
                      />
                    ) : (
                      'invisible'
                    )}
                  </td>
                  <td style={{textAlign: 'center'}}>
                    <Trash onClick={this.handleRemove(index)} />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>

        <Action onClick={this.saveConfiguration}>Save settings</Action>
      </>
    );
  }
}
